import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { compactFromU8a, compactToU8a, isU8a } from '@polkadot/util';
import { typeToConstructor } from "../utils/index.js";

function noopSetDefinition(d) {
  return d;
}
/**
 * @name Compact
 * @description
 * A compact length-encoding codec wrapper. It performs the same function as Length, however
 * differs in that it uses a variable number of bytes to do the actual encoding. This is mostly
 * used by other types to add length-prefixed encoding, or in the case of wrapped types, taking
 * a number and making the compact representation thereof
 */


var _Type = /*#__PURE__*/new WeakMap();

var _raw = /*#__PURE__*/new WeakMap();

export var Compact = /*#__PURE__*/function () {
  function Compact(registry, Type) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        definition = _ref.definition,
        _ref$setDefinition = _ref.setDefinition,
        setDefinition = _ref$setDefinition === void 0 ? noopSetDefinition : _ref$setDefinition;

    _classCallCheck(this, Compact);

    _classPrivateFieldInitSpec(this, _Type, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _raw, {
      writable: true,
      value: void 0
    });

    this.registry = registry;

    _classPrivateFieldSet(this, _Type, definition || setDefinition(typeToConstructor(registry, Type)));

    var _Compact$decodeCompac = Compact.decodeCompact(registry, _classPrivateFieldGet(this, _Type), value),
        _Compact$decodeCompac2 = _slicedToArray(_Compact$decodeCompac, 2),
        raw = _Compact$decodeCompac2[0],
        decodedLength = _Compact$decodeCompac2[1];

    this.initialU8aLength = decodedLength;

    _classPrivateFieldSet(this, _raw, raw);
  }

  _createClass(Compact, [{
    key: "encodedLength",
    get:
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    function get() {
      return this.toU8a().length;
    }
    /**
     * @description returns a hash of the contents
     */

  }, {
    key: "hash",
    get: function get() {
      return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return _classPrivateFieldGet(this, _raw).isEmpty;
    }
    /**
     * @description Returns the number of bits in the value
     */

  }, {
    key: "bitLength",
    value: function bitLength() {
      return _classPrivateFieldGet(this, _raw).bitLength();
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */

  }, {
    key: "eq",
    value: function eq(other) {
      return _classPrivateFieldGet(this, _raw).eq(other instanceof Compact ? _classPrivateFieldGet(other, _raw) : other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      return {
        outer: [this.toU8a()]
      };
    }
    /**
     * @description Returns a BigInt representation of the number
     */

  }, {
    key: "toBigInt",
    value: function toBigInt() {
      return _classPrivateFieldGet(this, _raw).toBigInt();
    }
    /**
     * @description Returns the BN representation of the number
     */

  }, {
    key: "toBn",
    value: function toBn() {
      return _classPrivateFieldGet(this, _raw).toBn();
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */

  }, {
    key: "toHex",
    value: function toHex(isLe) {
      return _classPrivateFieldGet(this, _raw).toHex(isLe);
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExtended) {
      return _classPrivateFieldGet(this, _raw).toHuman(isExtended);
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return _classPrivateFieldGet(this, _raw).toJSON();
    }
    /**
     * @description Returns the number representation for the value
     */

  }, {
    key: "toNumber",
    value: function toNumber() {
      return _classPrivateFieldGet(this, _raw).toNumber();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "Compact<".concat(this.registry.getClassName(_classPrivateFieldGet(this, _Type)) || _classPrivateFieldGet(this, _raw).toRawType(), ">");
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      return _classPrivateFieldGet(this, _raw).toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      return compactToU8a(_classPrivateFieldGet(this, _raw).toBn());
    }
    /**
     * @description Returns the embedded [[UInt]] or [[Moment]] value
     */

  }, {
    key: "unwrap",
    value: function unwrap() {
      return _classPrivateFieldGet(this, _raw);
    }
  }], [{
    key: "with",
    value: function _with(Type) {
      var definition; // eslint-disable-next-line no-return-assign

      var setDefinition = function setDefinition(d) {
        return definition = d;
      };

      return /*#__PURE__*/function (_Compact) {
        _inherits(_class, _Compact);

        var _super = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super.call(this, registry, Type, value, {
            definition: definition,
            setDefinition: setDefinition
          });
        }

        return _createClass(_class);
      }(Compact);
    }
    /** @internal */

  }, {
    key: "decodeCompact",
    value: function decodeCompact(registry, Type, value) {
      if (isU8a(value)) {
        var _compactFromU8a = compactFromU8a(value),
            _compactFromU8a2 = _slicedToArray(_compactFromU8a, 2),
            decodedLength = _compactFromU8a2[0],
            bn = _compactFromU8a2[1];

        return [new Type(registry, bn), decodedLength];
      } else if (value instanceof Compact) {
        return [new Type(registry, _classPrivateFieldGet(value, _raw)), 0];
      } else if (value instanceof Type) {
        return [value, 0];
      }

      return [new Type(registry, value), 0];
    }
  }]);

  return Compact;
}();